export const showTableLines = [
  { value: '15', label: '15 items' },
  { value: '20', label: '20 items' },
  { value: '50', label: '50 items' },
];
